__turbopack_context__.v({
  "buttonBox": "styles-module-scss-module__SGxLQa__buttonBox",
  "facebookBtn": "styles-module-scss-module__SGxLQa__facebookBtn",
  "icon": "styles-module-scss-module__SGxLQa__icon",
  "loading": "styles-module-scss-module__SGxLQa__loading",
  "text": "styles-module-scss-module__SGxLQa__text",
});
